module.exports = __webpack_public_path__ + "static/media/wallet-icon.6f02ca8a.svg";